export default "__VITE_ASSET__299bdd96__"